import { FileImage, FileText, FileAudio } from 'lucide-react'
import { memo } from 'react'
import { createPortal } from 'react-dom'

const DragUpload = memo(({ isDragging }: any) => {
  // 非拖拽时不显示
  if (!isDragging) return

  return createPortal(
    <div className="fixed z-[9999] inset-0 w-full h-full backdrop-blur-lg flex items-center justify-center">
      <div className="p-8 rounded-lg flex flex-col items-center justify-center gap-3 text-gray-700 bg-[rgba(255,255,255,0.3)]">
        <div className="flex gap-6">
          <FileImage size={36} strokeWidth={1.5} />
          <FileText size={36} strokeWidth={1.5} />
          <FileAudio size={36} strokeWidth={1.5} />
        </div>
        <div className="flex flex-col items-center justify-center gap-3 text-center">
          <div className="text-xl">拖拽文件到此处完成上传</div>
          <div className="text-base text-gray-500">
            <div>图片一次最多上传6张，其他文件一次最多上传一个</div>
            <div>支持文件类型：图片、文档、音频、视频</div>
            <div>具体请按照文件类型支持的格式上传</div>
          </div>
        </div>
      </div>
    </div>,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.querySelector('#root')!,
  )
})

export default DragUpload
